import React from "react";

import { usePortfolioBuilderContext } from "../PortfolioBuilder/reducer/Context";

import AssetClassRow from "./TableRow/AssetClassRow";
import BottomRow from "./TableRow/BottomRow";
import TopRow from "./TableRow/TopRow";

import styles from "./ModelBuilderTable.module.css";

const ModelBuilderTable: React.FC = () => {
  const { state } = usePortfolioBuilderContext();

  return (
    <div className={styles.container}>
      <TopRow />

      {state.modelTable.map((assetClass) => (
        <AssetClassRow
          key={assetClass.id}
          id={assetClass.id}
          name={assetClass.name}
          assetClassCategory={assetClass.category}
          assetClassId={assetClass.assetClassId}
          weight={assetClass.weight}
          isLocked={assetClass.isLocked}
          expand={assetClass.expand}
          isInvisible={assetClass.isInvisible}
          elementChildren={assetClass.children}
        />
      ))}

      <BottomRow />
    </div>
  );
};

export default ModelBuilderTable;
